<div [class]="cssClass">

  <div
    statistic
    statisticElementName="Click dropdown Expirations or Type"
    (click)="toggleDropdown($event)"
    *ngIf="type == '' || type == 'expirations' || type =='type'"
    [class.pressed]="showDropdown"
    class="iv-select"
  >
    <span *ngIf="label" class="label">{{label}}</span>
    <span *ngIf="label" class="separator">|</span>
    <input
      [style.padding-left]="(!label && type=='type') ? '10px': '0'"
      class="value"
      readonly
      value="{{getValue(selectedData)}}"
    >
  </div>

  <div
    statistic
    statisticElementName="Click dropdown Strike"
    (click)="toggleDropdown($event)"
    *ngIf="type == 'strike'"
    [class.pressed]="showDropdown"
    class="iv-select"
  >
    <span *ngIf="label" class="label">{{label}}</span>
    <span *ngIf="label" class="separator">|</span>
    <input
      (change)="changeValue($event)"
      (input)="inputValue($event)"
      [readonly]="selectedData === 'All'"
      [style.padding-left]="label? '0' : '10px'"
      class="value"
      value="{{getValue(selectedData)}}"
    >
  </div>

  <div
    (click)="toggleDropdown($event)"
    *ngIf="type == 'button' || type == 'ivx'"
    [class.pressed]="showDropdown"
    [class.with-tip]="tip"
    class="iv-select">
    <span class="label">{{addPercentSuffix ? label + ' (%)' : label}}
      <span
        *ngIf="tip"
        class="tip"
        style="left: -10px; width: auto; white-space: nowrap;"
      >
        {{tip}}
      </span>
    </span>
  </div>

  <ul *ngIf="showDropdown" [ngStyle]="dropdownOffset ? dropdownOffset : null">
    <dx-scroll-view
      [class.mac]="isMac"
      [height]="data.length > 5 ? '200px' : data.length * 32 + 'px'"
      [width]="'100%'"
      direction="Both"
    >
      <li
        (click)="onItemClick($event, item)"
        statistic
        statisticElementName="Select item in any option chain dropdowns"
        *ngFor="let item of data"
        [class.selected]="valueHasItem(item)"
      >
        {{getValue(item)}}
      </li>
    </dx-scroll-view>

    <ng-content></ng-content>
  </ul>
</div>
